<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-spinning`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M9 9V6H5v7h7v4.153C5.77 18.115 1 23.5 1 30c0 7.18 5.82 13 13 13h26l.25-.004A8 8 0 0042 27.252V22h2v-4h-8v4h2v3.662l-19.407-7.84-.004.011a12.916 12.916 0 00-2.588-.68L16 13h7V6h-4v3H9zm18 21c0-1.712-.331-3.348-.933-4.845l8.925 3.606A7.985 7.985 0 0032 35c0 1.458.39 2.824 1.07 4.001h-9.69A12.957 12.957 0 0027 30zm-13-9a9 9 0 100 18 9 9 0 000-18zm22 14a4 4 0 118 0 4 4 0 01-8 0zM14 24a6 6 0 110 12 6 6 0 010-12zm-2 6a2 2 0 114 0 2 2 0 01-4 0z"/></svg>
</template>
<script>

export default {
  name: 'IconSpinning',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
